import React, { useState } from 'react';
import { Grid } from '@material-ui/core';
import EventIcon from '@material-ui/icons/Event';
import DateFnsUtils from '@date-io/date-fns';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import './datePicker.css'

const DatePickerField = ({ id, name, label, handleDatePicker, helperText, defaultDate }) => {
  const [selectedDate, setSelectedDate] = useState(null);
  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <Grid container justifyContent="space-around">
        <KeyboardDatePicker
          margin="normal"
          id={id}
          label={label}
          format="MM/dd/yyyy"
          variant='inline'
          inputVariant='outlined'
          autoOk={true}
          okLabel=''
          ampm={false}
          size={'small'}
          value={selectedDate}
          animateYearScrolling
          onChange={(date) => { setSelectedDate(date);handleDatePicker(date)}}
          format="yyyy-MM-dd"
          views={['year', 'month', 'date']}
          helperText={helperText}
          KeyboardButtonProps={{
            'aria-label': 'change date',
          }}
          style={{ margin: 0 }}
        />

      </Grid>
    </MuiPickersUtilsProvider>
  );
};


export default DatePickerField;
